import axios from 'axios/index';

class BaseApi {
  METHOD_POST = 'POST';
  METHOD_GET = 'GET';

  /**
   * @param {string} url
   * @param {number} timeout
   */
  constructor (url, timeout) {
    this.url = url;
    this.timeout = timeout;
  }

  /**
   * @param {string} method
   * @param {string} path
   * @param {string} token
   * @param params
   * @returns {Promise<*>}
   */
  async makeRequest(method, path, token, params) {
    const url = `${this.url}/${path}`;
    const headers = { 'Content-Type': 'application/json' };

    if (typeof token === 'string') {
      headers['Authorization'] = token;
    }

    const config = {
      method,
      url,
      responseType: 'json',
      headers,
      data: params,
    };

    const response = await axios(config);

    return response.data;
  }
}


export default BaseApi;
